// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"SelfiesTip_style_b-icon-warning__WEiIf","wrapper":"SelfiesTip_style_wrapper__zll8X","rotate":"SelfiesTip_style_rotate__xDYIL"};